document.addEventListener("DOMContentLoaded", function(){

    var mobile = document.querySelector("#mobile_input");
    if(mobile !== null){
        mobile_input = window.intlTelInput(mobile,{
            utilsScript: '/intl-tel-input-16.0.0/build/js/utils.js',
            separateDialCode: true
        });
    }

});


$(document).ready(function() {

    //When selecting a scenario it makes sure the Sessions Count is required.
    $('.scenario-list .scenario-checkbox').on('change', function() {
        var selectedScenario = $(this).val();
        if (this.checked) {
            $('#scenario_'+selectedScenario).attr('required', 'required');
        } else {
            $('#scenario_'+selectedScenario).removeAttr('required');
        }
    });

    $('#client_form').submit(function(e) {
        e.preventDefault();
        document.getElementById('mobile_input').value = mobile_input.getNumber();
        let formData = new FormData(this);
        if(validateMobile()){
            ajaxCall(formData);
        }
    });

    function validateMobile(){
        var front_pass = true;
        if(!mobile_input.isValidNumber()){
            front_pass = false;
            var phone_errs = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
            var ph_err_num = mobile_input.getValidationError();
            var msg = "You must enter a valid phone number. " + phone_errs[ph_err_num] + '.';
            $('#mobile_input_err').html(msg).css('visibility','visible');
            location.hash = '#mobile_input_err';
        }else{
            $('#mobile_input_err').html('&nbsp;').css('visibility','hidden');
        }
        return front_pass;
    }

    function ajaxCall(data){
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('[name="csrf-token"]').val()
            }
        });
        $.ajax({
            type: 'POST',
            url: '/api/client/simclusive',
            data: data,
            processData: false,
            contentType: false,
            cache: false,
            success: function(response){
                if(response.success) {
                    $('#partner-application-button').attr('disabled',true);
                    $('#client_success').removeClass('d-none');
                    $('#client_form').addClass('d-none');
                    $('#error_block').html('');
                    $('#error_block').addClass('d-none');
                } else {
                    $('#error_block').removeClass('d-none');

                    let err_str = '';
                    $.each(response.message, function(index, value) {
                        err_str += '<div>' + value + '</div>';
                    });
                    $('#error_block').html(err_str);

                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('#error_block').offset().top
                    }, 1000);
                }
            },
            error: function(error){
                console.log('error');
                $('#error_block').removeClass('d-none');
                $('#error_block').html('There was an error processing your request. Please contact support@simclusive.com for assistance.');
                $([document.documentElement, document.body]).animate({
                    scrollTop: $('#error_block').offset().top
                }, 1000);
            }
        });
    }

});